<template>
    <div id="app" :class="[$route.name ]" :data-view="$route.name">
      <router-view />
    </div>
</template>

